module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "produk-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Kode Voucher',
          to: {
            path: '/kode-voucher'
          },
          exact: true,
        },
        {
          text: !_vm.$route.query.id ?
            'Tambah Kode Voucher' :
            'Ubah Kode Voucher',
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Tambah Kode Voucher" : "Ubah Kode Voucher") + "\n    ")]), _vm._v(" "), _c('v-card', {
    staticClass: "pa-7",
    attrs: {
      "plain": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-600 pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                    Nama Voucher *\n                ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "placeholder": "Nama Paket",
      "maxLength": "50",
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: (_vm.data.package_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_name", $$v)
      },
      expression: "data.package_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-600 pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                                Waktu Mulai *\n                            ")]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": true,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "disabled": _vm.queryId,
            "append-icon": "mdi-calendar",
            "placeholder": "Tanggal",
            "readonly": "",
            "outlined": ""
          },
          model: {
            value: (
              _vm.data.start_date
            ),
            callback: function($$v) {
              _vm.$set(_vm.data, "start_date", $$v)
            },
            expression: "\n                                                        data.start_date\n                                                    "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }])
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "disabled": _vm.queryId,
      "min": new Date()
        .toISOString()
        .slice(0, 10),
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.data.start_date),
      callback: function($$v) {
        _vm.$set(_vm.data, "start_date", $$v)
      },
      expression: "data.start_date"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-600 pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                                Waktu Berakhir *\n                            ")]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": true,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "disabled": _vm.queryId,
            "append-icon": "mdi-calendar",
            "placeholder": "Tanggal",
            "readonly": "",
            "outlined": ""
          },
          model: {
            value: (
              _vm.data.expiry_date
            ),
            callback: function($$v) {
              _vm.$set(_vm.data, "expiry_date", $$v)
            },
            expression: "\n                                                        data.expiry_date\n                                                    "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }])
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "disabled": _vm.queryId,
      "min": new Date()
        .toISOString()
        .slice(0, 10),
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.data.expiry_date),
      callback: function($$v) {
        _vm.$set(_vm.data, "expiry_date", $$v)
      },
      expression: "data.expiry_date"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-600 pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                    Pilihan Paket Belajar *\n                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "outlined": "",
      "placeholder": "Pilihan Paket Belajar",
      "disabled": !!_vm.queryId,
      "items": [{
          text: 'PACKAGES',
          value: 'PACKAGES'
        },
        {
          text: 'ADDON',
          value: 'ADDON'
        } ]
    },
    on: {
      "change": function($event) {}
    },
    model: {
      value: (_vm.data.package_category),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_category", $$v)
      },
      expression: "data.package_category"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-600 pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                    Jumlah Voucher *\n                ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "type": "number",
      "placeholder": "Nama Paket",
      "maxLength": "5",
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: (_vm.data.package_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_name", $$v)
      },
      expression: "data.package_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-600 pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                    Batas Penggunaan per User *\n                ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "type": "number",
      "placeholder": "Nama Paket",
      "maxLength": "5",
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: (_vm.data.package_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_name", $$v)
      },
      expression: "data.package_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-600 pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                    Kode Voucher *\n                ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "placeholder": "Nama Paket",
      "maxLength": "5",
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: (_vm.data.package_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_name", $$v)
      },
      expression: "data.package_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0 mb-5"
  }, [_c('v-list-item-title', [_c('span', {
    staticClass: "font-weight-700",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Pengaturan Diskon")])])], 1), _vm._v(" "), (_vm.data.package_category !== 'ADDON') ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                    Tipe Diskon *\n                ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "mandatory": ""
    },
    on: {
      "change": function($event) {
        _vm.data.package_grade = []
      }
    },
    model: {
      value: (_vm.data.package_level),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_level", $$v)
      },
      expression: "data.package_level"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "% Persen Diskon",
      "value": "1",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Nominal Diskon",
      "value": "2",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-600 pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                    Persen Diskon\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "Dalam Bentuk Persen (%)",
      "outlined": ""
    },
    model: {
      value: (_vm.data.consul_session),
      callback: function($$v) {
        _vm.$set(_vm.data, "consul_session", $$v)
      },
      expression: "data.consul_session"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-2 mt-5"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/kode-voucher'
        })
      }
    }
  }, [_vm._v("\n                Batal\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        !_vm.$route.query.id ? _vm.saveData() : _vm.editData()
      }
    }
  }, [_vm._v("\n                Simpan\n            ")])], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e29ef91a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pembayaran/components/VoucherCodeForm.vue
// module id = 2050
// module chunks = 1